<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.snackbar"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="diskominfo" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, setting perusahaan
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.color"
          @keydown.esc="dialog.color = false"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Color Palettes

              <v-spacer/>

              <v-icon 
                @click="dialog.color = false"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text
              class="mt-4">
              <v-color-picker
                v-model="color_picker"
                width="500"
                dot-size="15"
                mode="hexa"
                show-swatches
                swatches-max-height="100">
              </v-color-picker>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                @click="addColor()"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Save
              </v-btn>

              <v-btn
                @click="dialog.color = false"
                outlined
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize red--text">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="diskominfo"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Perusahaan
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7; height: calc(100vh - 250px); overflow-y: auto; overflow-x: hidden;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="3"
                          class="py-0">
                          <div
                            class="mb-6">
                            <div class="body-2 mb-2">
                              <!-- <span class="red--text">*</span> -->

                              Gambar
                            </div>

                            <uploadlogo
                              v-model="upload.logo" 
                              style="width: 275px; height: 275px;">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  width="275"
                                  height="275"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="form.logo.length < 1">
                                    <v-icon v-if="!process.logo"
                                      size="60" 
                                      color="grey">
                                      mdi-cloud-upload-outline
                                    </v-icon>

                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>

                                  <v-img v-else
                                    contain
                                    width="275"
                                    height="275"
                                    :src="form.logo.length > 0 ? form.logo : require('@/assets/logo/favicon.png')" 
                                    gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                                    :alt="form.logo"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.logo"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>

                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadlogo>
                          </div>

                          <div>
                            <uploadfavicon
                              v-model="upload.favicon" 
                              style="width: 150px; height: 150px;">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  width="150"
                                  height="150"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="form.fav_icon.length < 1">
                                    <v-icon v-if="!process.favicon"
                                      size="40" 
                                      color="grey">
                                      mdi-cloud-upload-outline
                                    </v-icon>

                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>

                                  <v-img v-else
                                    contain
                                    width="150"
                                    height="150"
                                    :src="form.fav_icon.length > 0 ? form.fav_icon : require('@/assets/logo/favicon.png')" 
                                    gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                                    :alt="form.fav_icon"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.favicon"
                                        size="40" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>

                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadfavicon>
                          </div>
                        </v-col>

                        <v-col
                          cols="12"
                          md="9"
                          class="py-0">
                          <v-row>
                            <v-col
                              cols="12"
                              md="12"
                              class="pt-0">
                              <ValidationProvider 
                                name="Nama Perusahaan" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Nama Perusahaan
                                </div>

                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Contoh. PT UCT"

                                  hide-details

                                  v-model="form.company_name"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.company_name !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col
                              cols="12"
                              md="12"
                              class="pt-0">
                              <ValidationProvider 
                                name="Email" 
                                rules="required|email" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Email
                                </div>

                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  rounded
                                  dense

                                  :color="set_color"
                                  placeholder="Contoh. company@gmail.com"

                                  hide-details

                                  v-model="form.email"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.email !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </v-col>

                            <v-col
                              cols="12"
                              md="12"
                              class="pt-0">
                              <ValidationProvider 
                                name="Alamat" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Alamat
                                </div>

                                <v-textarea
                                  filled
                                  rounded
                                  dense
                                  rows="3"
                                  auto-grow

                                  :color="set_color"
                                  placeholder="Contoh. Jl. DI Panjaitan No.22, Mantrijeron, Kec. Mantrijeron, Kota Yogyakarta"

                                  hide-details

                                  v-model="form.address"
                                  :success="valid"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>

                                    <div v-if="form.address !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-textarea>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <div
                            class="mb-4">
                            <div 
                              class="body-2 mb-2">
                              Color Palettes
                            </div>

                            <v-card
                              flat
                              color="#f0f0f0"
                              style="border-radius: 10px;">
                              <v-card-text>
                                <v-btn
                                  @click="dialog.color = true"
                                  color="#4B4B4B"
                                  elevation="0"
                                  class="body-2 white--text text-capitalize d-flex align-center"
                                  style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                  <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                                  
                                  <span
                                    class="ml-2">
                                    {{ Object.keys(form.color).length > 0 ? 'Ubah' : 'Tambah'}}
                                  </span>
                                </v-btn>

                                <div v-if="Object.keys(form.color).length > 0"
                                  class="mt-6">
                                  <v-chip
                                    :color="form.color.hex"
                                    @click:close="removeColor(index)"
                                    close
                                    label
                                    class="body-2 mr-2 mb-2"
                                    text-color="white"
                                    style="height: 36px; border-radius: 10px !important;">
                                    <!-- <v-icon v-if="item.active"
                                      size="20" 
                                      color="white" 
                                      class="mr-2">
                                      mdi-check-bold
                                    </v-icon> -->

                                    {{ form.color.hex }}
                                  </v-chip>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>

                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="20">mdi-checkbox-marked-circle-outline</v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          color: false
        },

        color_picker: '',

        form: {
          id: '',
          company_name: '',
          email: '',
          address: '',
          logo: '',
          fav_icon: '',
          color: []
        },

        time: {
          start: false,
          end: false
        },

        upload: {
          favicon: null,
          logo: null
        },

        process: {
          load: false,
          form: false,

          favicon: false,
          logo: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfavicon: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploadlogo: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.favicon': {
        handler: function () {
          if (this.upload.favicon) {
            this.process.favicon = this.upload.favicon.process

            if (!this.process.favicon) {
              // CALLBACK FROM UPLOAD IMAGE

              this.form.fav_icon = this.upload.favicon.fileuri
            }
          }
        },
        deep: true
      },

      'upload.logo': {
        handler: function () {
          if (this.upload.logo) {
            this.process.logo = this.upload.logo.process

            if (!this.process.logo) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.logo = this.upload.logo.fileuri
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        await get('config/data')
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            let form = {}
            if(res.results.data.length < 1) {
              this.form = {
                company_name: '',
                email: '',
                address: '',
                logo: '',
                fav_icon: '',
                color: [],
                id: ''
              }
              form = {
                company_name: '',
                email: '',
                address: '',
                logo: '',
                fav_icon: '',
                color: [],
                id: ''
              }
            } else {
              // res.results.data[0].color = res.results.data[0].color_object

              this.form = {
                id: res.results.data[0].id,
                company_name: res.results.data[0].company_name,
                email: res.results.data[0].email || '',
                address: res.results.data[0].address || '',
                logo: res.results.data[0].logo,
                fav_icon: res.results.data[0].fav_icon,
                color: res.results.data[0].color_object,
                font_object: res.results.data[0].font_object
              }
              form = {
                id: res.results.data[0].id,
                company_name: res.results.data[0].company_name,
                email: res.results.data[0].email || '',
                address: res.results.data[0].address || '',
                logo: res.results.data[0].logo,
                fav_icon: res.results.data[0].fav_icon,
                color: res.results.data[0].color_object,
                font_object: res.results.data[0].font_object
              }

            }
            // this.form.company_name = 'Kominfo Klaten',
            // this.form.logo = 'https://picsum.photos/500/300?image=20',
            // this.form.fav_icon = 'https://picsum.photos/500/300?image=20',
            // this.form.color = [
            //   {
            //     active:true,
            //     hex:"#080679"
            //   }
            // ]

            TokenService.saveCompany(JSON.stringify(form))

            this.$store.commit("setCompany", form)

            if (Object.keys(res.results.data[0].color_object).length > 0) {
              // res.results.data[0].color.map((obj) => {
              //   if (obj.active) {
                  TokenService.saveColor(res.results.data[0].color_object.hex)

                  this.$store.commit("setColor", res.results.data[0].color_object.hex)
                  TokenService.saveColor('#080679')

                  // this.$store.commit("setColor", '#080679')
              //   }
              // })
            } else {
              TokenService.saveColor('#080679')

              this.$store.commit("setColor", '#080679')
            }

            this.styles()
          }
        })
      },

      addColor () {
        this.form.color = {
          hex: this.color_picker,
          active: false
        }

        // if (this.form.color.length > 0 && this.form.color.filter((x,i) => { return x.active; }).length < 1) this.form.color[0].active = true

        this.dialog.color = false
      },
      removeColor (index) {
        this.form.color = {}

      },
      setActive (idx) {
        this.form.color.map((obj, index) => {
          if (index === idx) {
            obj.active = true
          } else {
            obj.active = false
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form),
              url = this.form.id == '' ? 'config/add' : 'config/update'
          // forms.color = forms.color

          // SAVE TO REST API

          await post(url, {
            data: {
              id: forms.id,
              company_name: forms.company_name,
              email: forms.email,
              address: forms.address,
              logo: forms.logo,
              fav_icon: forms.fav_icon,
              font_object: {},
              color_object: forms.color
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      }
    }
  }
</script>